import { useMemo } from 'react';
import { AutomationStep, StepError } from '@/types/automationSteps.ts';

import { AutomationVersion } from '@/types/automations.ts';
import {
  buildStepDisabledInfoById,
  getAllStepChildren,
  isStepWithChildren,
} from '@/utils/stepUtils.ts';

const useAutomationVersionErrors = (automationVersion?: AutomationVersion): StepError[] => {
  return useMemo(() => {
    if (!automationVersion?.steps) return [];

    const disabledInfoById = buildStepDisabledInfoById(automationVersion.steps);

    const collectErrors = (steps: AutomationStep[]): StepError[] =>
      steps.flatMap((step) => {
        if (disabledInfoById.get(step.step_id)?.isEffectivelyDisabled) return [];

        return [
          ...step.errors,
          ...(isStepWithChildren(step) ? collectErrors(getAllStepChildren(step)) : []),
        ];
      });

    return collectErrors(automationVersion.steps);
  }, [automationVersion]);
};

export default useAutomationVersionErrors;
